import { useTranslation } from "react-i18next";
import { Shield, Heart, Clock, Users, Activity, FileCheck } from "lucide-react";

export default function Benefits() {
  const { t } = useTranslation();

  const benefits = [
    { icon: Clock, title: t("benefits.ben1Title"), description: t("benefits.ben1Desc") },
    { icon: Shield, title: t("benefits.ben2Title"), description: t("benefits.ben2Desc") },
    { icon: Users, title: t("benefits.ben3Title"), description: t("benefits.ben3Desc") },
    { icon: Heart, title: t("benefits.ben4Title"), description: t("benefits.ben4Desc") },
    { icon: FileCheck, title: t("benefits.ben5Title"), description: t("benefits.ben5Desc") },
    { icon: Activity, title: t("benefits.ben6Title"), description: t("benefits.ben6Desc") }
  ];

  return (
    <section id="priekšrocības" className="section-spacing gradient-bg" data-testid="benefits-section">
      <div className="section-container">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <div className="relative order-2 lg:order-1">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl img-zoom">
              <img 
                src="https://customer-assets.emergentagent.com/job_senior-care-10/artifacts/suiryyvy_DSCF5348.jpg"
                alt="Senioru aprūpes sistēma ar 24/7 attālinātu uzraudzību — drošības risinājumi vecāka gadagājuma cilvēkiem"
                className="w-full h-[500px] object-cover"
                loading="lazy"
              />
            </div>
            <div className="absolute -bottom-6 -right-6 bg-white rounded-2xl p-6 shadow-xl border border-border">
              <div className="text-center">
                <p className="text-3xl font-bold text-primary mb-1" style={{ fontFamily: 'Manrope, sans-serif' }}>{t("benefits.stat")}</p>
                <p className="text-sm text-muted-foreground">{t("benefits.statLabel")}</p>
              </div>
            </div>
            <div className="absolute -top-6 -left-6 w-32 h-32 bg-accent/20 rounded-full blur-3xl" />
          </div>

          <div className="order-1 lg:order-2">
            <span className="inline-block bg-primary/10 text-primary px-4 py-2 rounded-full text-sm font-semibold mb-4">{t("benefits.badge")}</span>
            <p className="text-lg md:text-xl text-muted-foreground mb-10">{t("benefits.description")}</p>
            <div className="grid sm:grid-cols-2 gap-6">
              {benefits.map((benefit, index) => (
                <div key={index} className="flex gap-4" data-testid={`benefit-item-${index + 1}`}>
                  <div className="w-12 h-12 bg-primary/10 rounded-xl flex items-center justify-center flex-shrink-0">
                    <benefit.icon className="w-6 h-6 text-primary" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-foreground mb-1" style={{ fontFamily: 'Manrope, sans-serif' }}>{benefit.title}</h3>
                    <p className="text-sm text-muted-foreground leading-relaxed">{benefit.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
